import { render, staticRenderFns } from "./editMyUserInfo.vue?vue&type=template&id=5a604501&scoped=true&"
import script from "./editMyUserInfo.vue?vue&type=script&lang=js&"
export * from "./editMyUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a604501",
  null
  
)

export default component.exports